const CS_MAP_NAME_MAPPING: {
    [key: string]: {
        short: string;
        long: string;
    };
} = {
    de_dust2: {
        short: 'D2',
        long: 'Dust 2',
    },
    de_inferno: {
        short: 'Inf',
        long: 'Inferno',
    },
    de_overpass: {
        short: 'Ovp',
        long: 'Overpass',
    },
    de_mirage: {
        short: 'Mrg',
        long: 'Mirage',
    },
    de_nuke: {
        short: 'Nuk',
        long: 'Nuke',
    },
    de_vertigo: {
        short: 'Vrt',
        long: 'Vertigo',
    },
    de_ancient: {
        short: 'Anc',
        long: 'Ancient',
    },
};

export default function getMapNameFromMeta({
    map,
    format,
}: {
    map: string | undefined;
    format: 'short' | 'long';
}): string {
    if (!map) return '';

    return CS_MAP_NAME_MAPPING[map]?.[format] || map;
}
